import { apiAuth } from "../../http";

export const deletePost = async (id: string): Promise<[]> => {
  const response = apiAuth()
    .delete(`/posts/${id}`)
    .then(({ data }) => data);
  return response;
};
